/** Shared GASv3 vocabulary for the Your Work pinned-items funnel. */
export const PINS_ANALYTICS = {
	events: {
		pinnedWorkSectionViewed: { action: 'viewed', actionSubject: 'pinnedWorkSection' },
		searchWorkTabClicked: { action: 'clicked', actionSubject: 'searchWorkTab' },
		workItemSearched: { action: 'searched', actionSubject: 'workItem' },
		pinnedItemAdded: { action: 'added', actionSubject: 'pinnedItem' },
		pinnedItemRemoved: { action: 'removed', actionSubject: 'pinnedItem' },
		pinnedItemMutationFailed: { action: 'failed', actionSubject: 'pinnedItem' },
	},
	screens: {
		searchWork: 'searchWork',
	},
} as const;
